import * as React from 'react';
import { ArticleHeading2, ModalWindow, ArticleParagraph3 } from '@cian/ui-kit';
import * as styles from './styles.css';

const QUESTIONS = [
  'Какие есть варианты отделки?',
  'Когда сдаётся дом?',
  'Может, на других этажах есть квартиры дешевле?',
  'С каким банками работаете?',
  'Есть акции и скидки?',
];

export interface ILastHopePopupProps {
  builderName: string | null;
  callButton: React.ReactNode;
  isOpened: boolean;
  onClose(): void;
}

export function LastHopePopup({ builderName, callButton, isOpened, onClose }: ILastHopePopupProps) {
  return (
    <ModalWindow fixed={false} open={isOpened} onClose={onClose}>
      <div className={styles['container']} data-testid="LastHopePopupWithCallReasons">
        <div className={styles['content']}>
          <div className={styles['left']}>
            <ArticleHeading2>Спросите у застройщика</ArticleHeading2>
            <div className={styles['reasons']}>
              {QUESTIONS.map((question, index) => (
                <div key={index} className={styles['reason']}>
                  {question}
                </div>
              ))}
            </div>
          </div>
          <div className={styles['right']} />
        </div>

        <div className={styles['button']}>{callButton}</div>
        {builderName && <ArticleParagraph3 color="gray60_100">Застройщик {builderName}</ArticleParagraph3>}
      </div>
    </ModalWindow>
  );
}
